<template>
  <div class="xszn_tabs">
    <ul>
      <li v-for="(item, index) in menus" :class="{active: isCurrentMenu(item)}" :key="index"
          @click="handleMenu(item)">
        <p >
          <i class="czzn-tbs-icon" :class="item.className"></i>
          {{ item.name }}
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'tabs',
  props: ['menus'],
  // data() {
  //   return {
  //     menus: [
  //       { name: '如何购买', path: '/xszn/rhgm', className: 'xszn_tabs_p1' },
  //       { name: '新手引导', path: '/xszn/xsyd', className: 'xszn_tabs_p2' },
  //     ],
  //   };
  // },
  methods: {
    handleMenu(menu) {
      this.$router.push(menu.path);
    },
    isCurrentMenu(menu) {
      return menu.path === this.$route.fullPath;
    },
  },
};
</script>
